import {useOS} from '@aboutyou/utils';
import {useEffect, useState} from 'react';

/**
 * Hook to detect when the iOS keyboard is open/closed
 * Uses the Visual Viewport API to detect keyboard state on iOS devices
 */
export const useIOSKeyboardDetection = () => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [keyboardHeight, setKeyboardHeight] = useState(0);
  const isIOS = useOS() === 'ios';

  useEffect(() => {
    const viewport = window.visualViewport;

    if (!isIOS || !viewport) {
      return;
    }

    const handleResize = () => {
      const heightDifference = window.innerHeight - viewport.height;

      // Consider keyboard open if height difference is significant (more than 150px)
      // This threshold helps avoid false positives from browser UI changes
      const keyboardOpen = heightDifference > 150;

      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setIsKeyboardOpen(keyboardOpen);
      setKeyboardHeight(keyboardOpen ? heightDifference : 0);
    };

    viewport.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      viewport.removeEventListener('resize', handleResize);
    };
  }, [isIOS]);

  return {
    isKeyboardOpen,
    keyboardHeight,
  };
};
